const pageNameKey = "navigation";

export const navigationEn = {
  [pageNameKey]: {
    gateways: "Gateways",
    dashboards: "Dashboards",
    licences: "Licences",
    developerPanel: "Show Dev-Panel",
    usersIconButton: "Manage Users",
    ttLogoAltText: "Things OS Logo",
    productName: "Things OS",
    logoutButton: "Log out",
    developerButtonToolTip: "Open Developer Drawer",
    machines: "Machines",
    tickets: "Support Tickets",
    homepage: "Homepage",
    chatAI: "Open AI Chat",
    support: "Support",
    notifications: "Notifications",
    factoryDashboard: "Factory Dashboard",
    dashboardBuilder: "Dashboard Builder",
    dashboard: "Dashboard",
    adminPanel: "Admin Panel",
  },
};

export const navigationPtBr = {
  [pageNameKey]: {
    gateways: "Gateways",
    dashboards: "Painéis",
    licences: "Licenças",
    developerPanel: "Mostrar painel de desenvolvimento",
    usersIconButton: "Gerenciar usuários",
    ttLogoAltText: "Logo do Things OS",
    productName: "Things OS",
    logoutButton: "Sair",
    developerButtonToolTip: "Abrir painel do desenvolvedor",
    machines: "Máquinas",
    tickets: "Chamados de suporte",
    homepage: "Página inicial",
    chatAI: "Chat AI",
    support: "Suporte",
    notifications: "Notificações",
    factoryDashboard: "Painel de Fábrica",
    dashboardBuilder: "Construtor Dashboard",
    dashboard: "Dashboard",
    adminPanel: "Painel de Administração",
  },
};

export const navigationDe = {
  [pageNameKey]: {
    gateways: "Gateways",
    dashboards: "Dashboards",
    licences: "Licences",
    developerPanel: "Entwickler-Panel einblenden",
    usersIconButton: "Benutzer verwalten",
    ttLogoAltText: "Things OS Logo",
    productName: "Things OS",
    logoutButton: "Abmelden",
    developerButtonToolTip: "Entwickler-Panel öffnen",
    machines: "Maschinen",
    tickets: "Support-Tickets",
    homepage: "Startseite",
    chatAI: "Chat AI öffnen",
    support: "Support",
    notifications: "Benachrichtigungen",
    factoryDashboard: "Fabrik-Dashboard",
    dashboardBuilder: "Dashboard-Builder",
    dashboard: "Dashboard",
    adminPanel: "Admin-Panel",
  },
};

export const navigationZhHans = {
  [pageNameKey]: {
    gateways: "网关",
    dashboards: "仪表盘",
    licences: "许可证",
    developerPanel: "显示开发者面板",
    usersIconButton: "管理用户",
    ttLogoAltText: "Things OS Logo",
    productName: "Things OS",
    logoutButton: "登出",
    developerButtonToolTip: "打开开发者抽屉",
    machines: "机器",
    tickets: "支持票务系统",
    homepage: "主页",
    chatAI: "聊天 AI",
    support: "支持",
    notifications: "通知",
    factoryDashboard: "工厂仪表盘",
    dashboardBuilder: "仪表盘构建器",
    dashboard: "仪表盘",
    adminPanel: "管理面板",
  },
};

export const navigationIt = {
  [pageNameKey]: {
    gateways: "Gateway",
    dashboards: "Dashboard",
    licences: "Licenze",
    developerPanel: "Mostra pannello sviluppatore",
    usersIconButton: "Gestisci utenti",
    ttLogoAltText: "Logo Things OS",
    productName: "Things OS",
    logoutButton: "Esci",
    developerButtonToolTip: "Apri pannello sviluppatore",
    machines: "Macchine",
    tickets: "Tickets",
    homepage: "Home",
    chatAI: "Apri Chat AI",
    support: "Supporto",
    notifications: "Notifiche",
    factoryDashboard: "Dashboard di fabbrica",
    dashboardBuilder: "Dashboard builder",
    dashboard: "Dashboard",
    adminPanel: "Pannello di amministrazione",
  },
};

export const navigationEs = {
  [pageNameKey]: {
    gateways: "Gateways",
    dashboards: "Dashboards",
    licences: "Licencias",
    developerPanel: "Mostrar panel de desarrollo",
    usersIconButton: "Gestionar usuarios",
    ttLogoAltText: "Logotipo de Things OS",
    productName: "Things OS",
    logoutButton: "Cerrar sesión",
    developerButtonToolTip: "Abrir panel de desarrollador",
    machines: "Máquinas",
    tickets: "Tickets de soporte",
    homepage: "Página principal",
    chatAI: "Abrir Chat AI",
    support: "Soporte",
    notifications: "Notificaciones",
    factoryDashboard: "Panel de fábrica",
    dashboardBuilder: "Constructor Dashboard",
    dashboard: "Dashboard",
    adminPanel: "Panel de administración",
  },
};

export const navigationNl = {
  [pageNameKey]: {
    chatAI: "AI Chat openen",
    dashboards: "Dashboards",
    developerButtonToolTip: "Ontwikkelaarspaneel openen",
    developerPanel: "Dev-paneel weergeven",
    factoryDashboard: "Fabrieksdashboard",
    gateways: "Gateways",
    homepage: "Startpagina",
    licences: "Licenties",
    logoutButton: "Afmelden",
    machines: "Machines",
    notifications: "Meldingen",
    productName: "Things OS",
    support: "Support",
    tickets: "Supporttickets",
    ttLogoAltText: "Things OS-logo",
    usersIconButton: "Gebruikers beheren",
    dashboardBuilder: "Dashboard Builder",
    dashboard: "Dashboard",
    adminPanel: "Admin-Panel",
  },
};

export const navigationTr = {
  [pageNameKey]: {
    chatAI: "AI Sohbetini Aç",
    dashboards: "Gösterge tabloları",
    developerButtonToolTip: "Geliştirici Çekmecesini Aç",
    developerPanel: "Geliştirici Panelini Göster",
    factoryDashboard: "Fabrika Kontrol Paneli",
    gateways: "Ağ geçitleri",
    homepage: "Ana sayfa",
    licences: "Lisanslar",
    logoutButton: "Oturumu kapat",
    machines: "Makineler",
    notifications: "Bildirimler",
    productName: "Şeyler İşletim Sistemi",
    support: "Destek",
    tickets: "Destek Biletleri",
    ttLogoAltText: "Şeyler İşletim Sistemi Logosu",
    usersIconButton: "Kullanıcıları Yönet",
    dashboard: "Kontrol Paneli",
    dashboardBuilder: "Kontrol Paneli Oluşturucu",
    adminPanel: "Yönetim Paneli",
  },
};
